var map = {
	"./person-qrcode.jpg": 3758,
	"./元习.jpg": 3819,
	"./元习小程序.jpg": 2952,
	"./双创思维.jpg": 5301,
	"./舟知.jpg": 5048,
	"./超级教案.jpg": 4800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4057;